import { GTMEvent } from '../../GTM'

export const adaptClearCart = () => {
  return {
    event: GTMEvent.CLEAR_CART,
    ecommerce: null,
  }
}
